// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1AHzj","icon":"style_icon__2NrnF"};